import { RouteObject } from 'react-router'

import { PLATFORM } from '@/constants/platform'
import { STREAMING_MENU_ICONS } from '@/router/icons'
import { UserAdminUsersView } from '@/views/UserAdmin'

export const userRoutes: RouteObject[] = [
  {
    path: 'users',
    label: 'Users',
    icon: STREAMING_MENU_ICONS.USERS,
    platforms: [PLATFORM.DGE],
    children: [
      {
        index: true,
        element: <UserAdminUsersView />,
        platforms: [PLATFORM.DGE]
      }
    ]
  }
]
